import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index-header py-6 px-6 d-flex" }

import {useRouter} from "vue-router";



export default /*@__PURE__*/_defineComponent({
  __name: 'PropHeader',
  emits: ['showOverlay'],
  setup(__props, { emit: __emit }) {

const emits = __emit
const router = useRouter()

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title text-h6 font-weight-bold text-white" }, " 数字化智能教学互动平台 ", -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        "prepend-icon": "mdi-chart-bar",
        class: "mr-6 btn",
        color: "white",
        variant: "text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('showOverlay')))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("查看排行")
        ])),
        _: 1,
        __: [2]
      }),
      _createVNode(_component_v_btn, {
        "prepend-icon": "mdi-home",
        variant: "text",
        class: "mr-4 btn",
        color: "white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/')))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" 返回首页 ")
        ])),
        _: 1,
        __: [3]
      })
    ])
  ]))
}
}

})